module.exports = __webpack_public_path__ + "static/media/cuadricula.3b3eb086.jpeg";